let chartType = ["skill", "best-lap", "time"];

let maxEventsToLoad = 100;
let loadEarlierButton;

$(function () {
    // Load the Visualization API and the piechart package.
    google.charts.load('current', {'packages':['corechart', 'controls', 'table']});

    // Set a callback to run when the Google Visualization API is loaded.
    google.charts.setOnLoadCallback(drawChart);

    $('[data-toggle="tooltip"]').tooltip();

    loadEarlierButton = document.getElementById("load-earlier");

    if (!loadEarlierButton) {
        return
    }

    loadEarlierButton.onclick = function () {
        maxEventsToLoad += 50;

        drawChart()
    };
});

function drawChart() {

    for (let i = 0; i < chartType.length; i++) {
        let skillChartDiv = document.getElementById('skill-chart-div');

        if (!skillChartDiv) {
            return
        }

        let id = skillChartDiv.previousElementSibling.id;

        let jsonData = $.ajax({
            url: "/ajax/" + id + "/" + chartType[i] + "/" + maxEventsToLoad + "/graph-data",
            dataType: "json",
            async: false
        }).responseText;

        // Create our data table out of JSON data loaded from server.
        let data = new google.visualization.DataTable(jsonData);

        let color;

        switch (chartType[i]) {
            case "safety":
                color = '#ffc107';
                break;
            case "skill":
                color = '#0384fc';
                break;
            case "consistency":
                color = "#0cc72e";
                break;
            case "best-lap":
                color = "#d92549";
                break;
            case "cuts":
                color = "#7d199c";
                break;
            case "time":
                color = "#ed951a";
                break;
            default:
                color = "#1bb5b2"
        }

        let options = {
            title: 'Driver ' + chartType[i].replace(/-/, " ").replace(/^\w/, c => c.toUpperCase()),
            curveType: 'function',
            legend: {position: 'bottom'},
            series: {
                0: {color: color},
            },
            theme: 'maximized',
        };


        let chart = new google.visualization.ChartWrapper({
            chartType: 'LineChart',
            containerId: chartType[i] + '-chart-div',
            options: options,
        });

        let control = new google.visualization.ControlWrapper({
            controlType: 'ChartRangeFilter',
            containerId: chartType[i] + '-control-div',
            options: {
                filterColumnIndex: 0,
                ui: {
                    chartType: 'LineChart',
                    'chartOptions': {
                        'chartArea': {'width': '100%'},
                        theme: 'maximized',
                        series: {
                            0: {color: color},
                        },
                    },
                },
            }
        });

        let table = new google.visualization.ChartWrapper({
            chartType: 'Table',
            containerId: chartType[i] + '-table-div',
            dataTable: data,
            options: {
                sortColumn: 1
            }
        });

        if (table.getDataTable().getNumberOfRows() < maxEventsToLoad) {
            loadEarlierButton.setAttribute("disabled", "disabled");
        }

        google.visualization.events.addListener(control, 'statechange', function () {
            let state = control.getState();

            let view = new google.visualization.DataView(data);

            view.setRows(view.getFilteredRows([{
                column: 0,
                minValue: state.range.start,
                maxValue: state.range.end
            }]));

            table.setDataTable(view);

            table.draw();
        });

        let dashboard = new google.visualization.Dashboard(document.getElementById(chartType[i] + '-dashboard'));
        dashboard.bind([control], [chart]);

        dashboard.draw(data);

        table.draw();
    }
}
